import { firestoreAction } from 'vuexfire'
import { db } from '@/plugins/firebase'
import {ga} from '@/main'

const state = {
    conversations: [],
    userAnswers:{},
    allAnswers:[]
}

const mutations = {
}

const actions = {
    bindConversations: firestoreAction(async ({ bindFirestoreRef, rootState, dispatch }) => {
        await bindFirestoreRef('conversations', db.collection("conversations").where("between", "array-contains", rootState.db.user.id)/*.orderBy("updatedTime", "desc")*/.limit(20));
        await dispatch("social/refreshUsersRef", null, {root: true});
    }),
    bindUserAnswers: firestoreAction(async ({ bindFirestoreRef, rootState, state, dispatch }, conv) => {
        await bindFirestoreRef('userAnswers', db.collection("conversations").doc(conv.id).collection("answers").doc(rootState.db.user.id));
        if(state.userAnswers && state.userAnswers.isDone){
            await dispatch('bindAllAnswers', conv);
        }
    }),
    bindAllAnswers: firestoreAction(async ({ bindFirestoreRef}, conv) => {
        await bindFirestoreRef('allAnswers', db.collection("conversations").doc(conv.id).collection("answers").where("isDone","==",true));
    }),
    createConversation: async function ({rootState, state}, {question, others, withTemplate}){
        let doc = await db.collection("conversations").add({
            question,
            between:[...others, rootState.db.user.id],
            withTemplate,
            createdTime: Date.now(),
            updatedTime: Date.now(),
            hasWritten:[],
        })
        ga.event('Conversations', 'create', doc.id, state.conversations.length);
        return doc.id;
    },
    saveAnswers: async function({rootState, getters, dispatch}, {answers, isDone, conv}){
        await db.collection("conversations").doc(conv.id).collection("answers").doc(rootState.db.user.id).set({
            answers,
            isDone,
            updatedTime: Date.now()
        })
        ga.event('Conversations', 'writing...', conv.id);
        if(isDone){
            await db.collection("conversations").doc(conv.id).update({
                hasWritten:[...new Set([...(conv.hasWritten || []), rootState.db.user.id])],
                updatedTime: Date.now()
            })
            await dispatch('bindAllAnswers', conv);
            ga.event('Conversations', 'done', conv.id);
        }
    },
    removeUser: async function({dispatch}, conv){
        await dispatch("deleteConv", conv);
    },
    deleteAllConversations: async function({rootState, dispatch}){
        let allConv = await db.collection("conversations").where("between", "array-contains", rootState.db.user.id).get();
        await Promise.all(allConv.docs.map(async doc => {
            await dispatch("deleteConv", {...doc.data(), id: doc.id});
        }));
    },
    deleteConv: async function({rootState}, conv){
        let newBetween = conv.between.filter(uid => uid !== rootState.db.user.id);

        if(newBetween.length > 0){
            await db.collection("conversations").doc(conv.id).update({
                between:newBetween,
                updatedTime: Date.now()
            })
        } else {
            let answers = await db.collection("conversations").doc(conv.id).collection("answers").get();
            await Promise.all(answers.docs.map(async doc => {
                await db.collection("conversations").doc(conv.id).collection("answers").doc(doc.id).delete();
            }))
            await db.collection("conversations").doc(conv.id).delete();
        }
        ga.event('Conversations', 'delete')
    },
}

const getters = {
    getConversation: state => id => {
        return state.conversations.find(c => c.id === id);
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}